module.exports = __webpack_public_path__ + "assets/img/portal.3c4875db.png";